// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Lx3I","colCheckbox":"styles_colCheckbox__3LA3t"};